import { render } from "./tripsComponent.vue?vue&type=template&id=3caa5db9&scoped=true"
import script from "./tripsComponent.vue?vue&type=script&lang=js"
export * from "./tripsComponent.vue?vue&type=script&lang=js"

import "./tripsComponent.vue?vue&type=style&index=0&id=3caa5db9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3caa5db9"]])

export default __exports__